import { forwardRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { blueGrey } from "@mui/material/colors";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DialogWrapper({ open, closer, title, children }) {
  return (
    <Dialog
      open={open}
      fullScreen
      onClose={() => closer()}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => closer()}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography
            variant="h6"
            color={blueGrey[100]}
            component="div"
            sx={{ ml: 2, flex: 1 }}
          >
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box>{children}</Box>
    </Dialog>
  );
}
